// extracted by mini-css-extract-plugin
module.exports = {"container":"DayHeader_container__16MA-","textAlignCenter":"DayHeader_textAlignCenter__2vFzP"};